export class ElementCreator {
    static createFromHtml(html) {
        const div = document.createElement('div');
        div.innerHTML = html.trim();
        return div.firstElementChild;
    }
}
